/* eslint-disable class-methods-use-this */
/* eslint-disable no-console */
/* eslint-disable no-use-before-define */
/* eslint-disable max-classes-per-file */

class Sandbox {
    core: Mediator;

    selector: string;

    CONTAINER: HTMLElement;

    constructor(core: Mediator, selector: string) {
        this.core = core;
        this.selector = selector;
        this.CONTAINER = document.getElementById(selector);
    }

    async get(
        url: string,
        data: Object = {},
        xhrFields: Object = {},
        retryCount: number = 3
    ): Promise<any> {
        return this.core.http.request(url, "GET", data, xhrFields, retryCount);
    }

    async post(
        url: string,
        data: any,
        xhrFields: Object = {},
        retryCount: number = 3
    ): Promise<any> {
        return this.core.http.request(url, "POST", data, xhrFields, retryCount);
    }

    async put(
        url: string,
        data: any,
        xhrFields: Object = {},
        retryCount: number = 3
    ): Promise<any> {
        return this.core.http.request(url, "PUT", data, xhrFields, retryCount);
    }

    async delete(
        url: string,
        xhrFields: Object = {},
        retryCount: number = 3
    ): Promise<any> {
        return this.core.http.request(url, "DELETE", {}, xhrFields, retryCount);
    }

    async deleteWithData(
        url: string,
        data: any = "",
        retryCount: number = 3
    ): Promise<any> {
        return this.core.http.request(url, "DELETE", data, {}, retryCount);
    }

    emit(coreEvent: CoreEvent) {
        this.core.publish(coreEvent);
    }

    on(type: string, handler: Function) {
        this.core.subscribe(this.selector, type, handler);
    }

    off(type: string) {
        this.core.unsubscribe(this.selector, type);
    }

    log(message: string, severity: number = 1) {
        this.core.log(severity, message);
    }
}

class Component {
    sandbox: Sandbox;

    constructor(sandbox: Sandbox) {
        this.sandbox = sandbox;
    }

    // eslint-disable-next-line no-unused-vars
    init(model: any, controller: Controller) {
        console.log("Init!");
    }

    destroy() {
        console.log("Destroy!");
    }

    // eslint-disable-next-line no-unused-vars
    controller(controller: Controller) {
        console.log("Controller!");
    }
}

class Controller {
    mediator: Mediator;

    constructor() {
        this.mediator = new Mediator();
    }

    model(): any {}

    registerComponent(componentId: string, component: any) {
        this.mediator.register(componentId, component);
    }

    injectService(name: string, service: any) {
        this.mediator.inject(name, service);
    }

    getService(name: string): any {
        return this.mediator.get(name);
    }

    start() {
        const model = this.model();
        if (model && model.then) {
            model
                .then((data) => {
                    this.mediator.startAll(data, this);
                })
                .catch((err) => {
                    console.error(err);
                    this.mediator.startAll(err, this);
                });
        } else {
            this.mediator.startAll(model, this);
        }
    }
}

class CoreEvent {
    type: string;
    data: Object;
    constructor(type: string, data: any) {
        this.type = type;
        this.data = data;
    }
}

class Mediator {
    debug: boolean;
    componentData: Object;
    services: Object;
    dom: Object;
    http: Object;

    constructor() {
        this.debug = true;
        this.componentData = {};
        this.services = {};

        this.http = {
            async request(
                url,
                type = "GET",
                data = {},
                xhrFields = {},
                retryCount = 3
            ) {
                let retries = retryCount;
                try {
                    return fetch(url, {
                        method: type, // *GET, POST, PUT, DELETE, etc.
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(data)
                    })
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (myJson) {
                            return myJson;
                        });
                } catch (err) {
                    retries -= 1;
                    if (retryCount) {
                        return this.request(url, type, data, xhrFields, retries);
                    }
                    return err;
                }
            },
        };
    }

    register<T>(componentId: string, component: T) {
        this.componentData[componentId] = {
            creator: component,
            instance: null,
            events: {},
        };
    }

    start(componentId: string, model: any, controller: Controller) {
        const component = this.componentData[componentId];
        // eslint-disable-next-line new-cap
        component.instance = new component.creator(new Sandbox(this, componentId));
        component.instance.init(model, controller);
        component.instance.controller(controller);
    }

    stop(componentId: string) {
        const component = this.componentData[componentId];
        if (component) {
            component.instance.destroy();
            component.instance = null;
        }
    }

    startAll(model: any, controller: Controller) {
        Object.keys(this.componentData).forEach((componentId) => {
            if ({}.hasOwnProperty.call(this.componentData, componentId)) {
                this.start(componentId, model, controller);
            }
        });
    }

    stopAll() {
        Object.keys(this.componentData).forEach((componentId) => {
            if ({}.hasOwnProperty.call(this.componentData, componentId)) {
                this.stop(componentId);
            }
        });
    }

    subscribe(componentId: string, type: string, handler: Function) {
        if (this.componentData[componentId]) {
            this.componentData[componentId].events[type] = handler;
        }
    }

    unsubscribe(componentId: string, type: string) {
        if (this.componentData[componentId]) {
            delete this.componentData[componentId].events[type];
        }
    }

    publish(coreEvent: CoreEvent) {
        Object.keys(this.componentData).forEach((componentId) => {
            if ({}.hasOwnProperty.call(this.componentData, componentId)) {
                const component = this.componentData[componentId];
                if (component.events && component.events[coreEvent.type]) {
                    component.events[coreEvent.type](coreEvent.data);
                }
            }
        });
    }

    inject(name: string, service: any) {
        this.services[name] = service;
    }

    get(service: string): any {
        return this.services[service];
    }

    isArray(arr: any): boolean {
        return Array.isArray(arr);
    }

    isObject(obj: any): boolean {
        return obj != null && typeof obj == 'object' && !Array.isArray(obj);
    }

    log(severity: number, message: string) {
        if (this.debug) {
            const method = {
                /* ::[ */ 1 /* ::] */: "log",
                /* ::[ */ 2 /* ::] */: "warn",
            };
            console[method[severity] || "error"](message);
        } else {
            // send to server
        }
    }
}

module.exports = {
    Core: {
        Mediator,
        Sandbox,
        Component,
        Event: CoreEvent,
        Controller,
    },
};
